import { Component, OnDestroy, OnInit, ViewChild, OnChanges, ChangeDetectorRef,ElementRef, Input, Pipe, PipeTransform , Directive, HostListener} from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import * as FileSaver from 'file-saver';
import { trigger, state, keyframes,style, transition, animate, animation } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { PaymentsService } from '../../services/payments.service';
import { OmsService } from '../../services/oms.service';

export enum KEY_CODE {
  PLUS = 107,
  MINUS = 109,
  TAB = 9,
  PLUSTWO = 187,
}

@Component({
	selector: 'app-counter-pos',
	templateUrl: './counter-pos.component.html',
	styleUrls: ['./counter-pos.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(-179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('inactive => active', animate('250ms ease-in')),
			transition('active => inactive', animate('250ms ease-out')),
		]),
		trigger("grow", [ // Note the trigger name
			transition(":enter", [
				// :enter is alias to 'void => *'
				style({ height: "0", width: "0" }),
				animate(200, style({ height: "*", width: "*" })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(":leave", [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0,})),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
		trigger('cinfo', [
			transition(':enter', [
				animate('50ms', style({ opacity: 1, height: 100 })),
			]),
			transition(':leave', [
				animate('100ms', style({ opacity: 1, height: 0 }))
			]),
		]),
		trigger('itemSearch', [
			transition(':enter', animation([style({ transform: 'translate(-800px,0)', }),
				animate('0.2s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(1200px,0)', })
				),
			])),
		]),
		trigger('addFilters', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
		trigger('navIn', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.10s cubic-bezier(0.59, 0.32, 0.38, 0.33)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.0s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
		trigger('shakeit', [
				state('shakestart', style({
					transform: 'scale(1)',
				})),
				state('shakeend', style({
					transform: 'scale(1)',
				})),
				transition('shakestart => shakeend', animate('1000ms ease-in',
				keyframes([
					style({transform: 'translate3d(-1px, 0, 0)', offset: 0.1}),
					style({transform: 'translate3d(2px, 0, 0)', offset: 0.2}),
					style({transform: 'translate3d(-4px, 0, 0)', offset: 0.3}),
					style({transform: 'translate3d(4px, 0, 0)', offset: 0.4}),
					style({transform: 'translate3d(-4px, 0, 0)', offset: 0.5}),
					style({transform: 'translate3d(4px, 0, 0)', offset: 0.6}),
					style({transform: 'translate3d(-4px, 0, 0)', offset: 0.7}),
					style({transform: 'translate3d(2px, 0, 0)', offset: 0.8}),
					style({transform: 'translate3d(-1px, 0, 0)', offset: 0.9}),
			]))),
		])
	],
})

export class CounterPosComponent implements OnInit {
	@ViewChild("inactiveModal") inactiveModalRef: ElementRef;
	@ViewChild("itemdetails") itemDetails: ElementRef;
	@ViewChild("taxdetails") taxdetailsRef: ElementRef;
	@ViewChild("purchasedetails") purchasedetails: ElementRef;
	@ViewChild("creditover") creditover: ElementRef;
	@ViewChild("configproductele") configproductele: ElementRef;
	@ViewChild("itemHistoryRef") itemHistoryRef: ElementRef;
	@ViewChild("nonstock") nonstockref: ElementRef;
	@ViewChild("itemQty") itemQtyRef: ElementRef;
	@ViewChild("editRow") editRowRef: ElementRef;
	@ViewChild("quoteModal") quoteModalRef: ElementRef;
	@ViewChild("orderModal") orderModalRef: ElementRef;

	@ViewChild("editCustomer") editCustomerRef: ElementRef;
	@ViewChild('monthDetails') monthDetailsRef: ElementRef;
	@ViewChild('empCode') empCodeRef: ElementRef;

	flip: any = 'inactive';
	states = {};

	pay_title; any = 'PAYMENT/RECEIPT';
	CHAT_ROOM = "OrderBoard";
	duration: any = 100;
	currentstep: number = 0;
	receipt_data : any = false;
	emperror : any = false;
	globalon: boolean = true;
	expand_details: boolean = true;
	orderResults: any = false;
	customer_data: any = [];
	customer_details: any = false;
	filters: any = [];
	debtorno: any = '';
	branchcode: any = '';
	today = new Date();
	lastsearch: any = '';
	order_result: any = false;
	//cart
	dspcost: boolean = true;
	showGuide: boolean = false;
	total_cart_qty: number = 0;
	cart_items: any = [];
	cart_totals: any = [];
	selectedindex: number = 0;
	payment_total: any = 0.00;
	activeLink: any = 'order_entry';

	//subscription to search
	inventorysearching: any = false;
	preOrderOpenState: boolean = false;

	search_items: any = [];
	filtered_items: any = [];
	searching: boolean = false;

	taxgroups: any = [];
	salespeople: any = [];
	shipvia: any = [];
	terms: any = [];
	zones: any = [];
	locations: any = [];
	holdreasons: any = [];
	itemhistory: any = [];
	datewanted = new UntypedFormControl(new Date());
	empcode = new UntypedFormControl();
	forceTax = new UntypedFormControl(false);
	email = new UntypedFormControl();
	globalDiscount = new UntypedFormControl('0');
	limits = [
		{ name: '25', value: '25' },
		{ name: '50', value: '50' },
		{ name: '100', value: '100' },
		{ name: '150', value: '150' },
		{ name: '250', value: '200' },
		{ name: '500', value: '500' },
		{ name: 'No Limit', value: false },
	];

	sorts = [
		{ name: 'All Availability, Sell Low To High', value: 'avail.sell|ASC' },
		{ name: 'All Availability, Sell High To Low', value: 'avail.sell|DESC' },
		{ name: 'Local Availability, Sell Low To High', value: 'local.sell|ASC' },
		{ name: 'Local Availability, Sell High To Low', value: 'local.sell|DESC' },
		{ name: 'Sell Low To High', value: 'price|ASC' },
		{ name: 'Sell High To Low', value: 'price|DESC' },
		{ name: 'Name ASC', value: 'description|ASC' },
		{ name: 'Name DESC', value: 'description|DESC' },
	];

	itemSearchForm: UntypedFormGroup;
	customerForm: UntypedFormGroup

	customerEditAllowed = [
		'debtorno',
		'branchcode',
		'name',
		'address1',
		'address2',
		'address3',
		'address4',
		'address5',
		'address6',
		'contactname',
		'brname',
		'braddress1',
		'braddress2',
		'braddress3',
		'braddress4',
		'braddress5',
		'braddress6',
		'email',
		'salesman',
		'salestype',
		'defaultshipvia',
		'phoneno',
		'faxno',
		'specialinstructions',
		'defaultlocation',
		'paymentterms',
		'tax_ref',
		'taxgroupid',
		'area',
		'datewanted',
		'enteredby',
		'takenby',
	]

	addonfields: [
		'datewanted',
		'enteredby',
		'takenby',
		'freightcost',
	];

	addingitems: boolean = false;
	customerinfo: boolean = true;
	//viewing item
	item_details: any = false;
	editing_order: boolean = false;
	order_details: any = [];
	purchase_items: any = [];
	user: any = false;

	showfilters: boolean = false;
	overcredit: boolean = false;
	allowed_credit: boolean = false;
	proceed: boolean = false;
	overcredit_override: string = '';
	selecteditem: any = false;
	config: any = [];

	nonStockForm: UntypedFormGroup;
	brands: any = [];
	librarysearch = new UntypedFormControl('');
	librarySearchResults: any = [];
	librarySearchSelected: any = false;
	librarySearching: any = false;
	collapseMini: any = false;
	fetchingCart: any = false;
	shipping: any = 0.00;
	cart_item: any = false;
	refusedemail: any = false;
	color: any = 'blue';

	dealsmissed: any = [];
	coupons: any = [];
	change_due: any = 0;
	coupon: any = '';
	payments: any = [{ 'paymentname': 'Cash', 'value': 0, 'fa_icon': 'fa-money' }, { 'paymentname': 'Check', 'value': 0, 'fa_icon': 'fa-newspaper-o' }];

	sending:any = false;
	brand_details: any = false;
	ref_location: any = false;
	payments_added: any = [];
	sendingdiscount: any = false;
	itemdetails: any = false;
	loggedemployee: any = false;
	acceptedNumbers: string[] = ['.', '', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];


	@HostListener('window:keyup', ['$event'])
	  keyEvent(event: KeyboardEvent) {

		if (event.keyCode === KEY_CODE.PLUS) {
			this.increment(this.cart_item)
			return false;
		}

		if (event.keyCode === KEY_CODE.MINUS) {
			this.decrement(this.cart_item)
			return false;
		}
	}

	constructor(private paymentsService: PaymentsService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService) {
		this.color = this.globalSearchService.getColor();
		this.config = this.globalsService.getApiConfig();

		this.globalSearchService.empCode.subscribe(r=> {
			if(r) {
				this.empcode.setValue(r);
				this.loggedemployee = r;
			}
		});

		this.globalSearchService.user.subscribe( results => {
			//only run if user is defined
			if(this.user) {

				if(results.user.defaultlocation.loccode != this.ref_location) {
					if(this.customer_data) {
						this.customer_data.defaultlocation = this.user.user.defaultlocation.loccode;
					}
					this.ref_location = false;
				}
			}

			this.user = results

			if(!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}

			this.globalSearchService.locations.subscribe(async (results: any) => {
				this.locations = results;

				if (results) {
					let val = [
						this.user.user.defaultlocation.loccode
					];

					if(this.customer_data) {
						this.customer_data.defaultlocation = this.user.user.defaultlocation.loccode;
					}
				}
			});

		});

		//shake screen ... misbehaving a bit shakes on load
		this.states['state1'] = 'shakestart';
		this.states['state2'] = 'shakestart';

		this.forceTax.valueChanges.subscribe(newValue=> {
			this.updateCart();
		});

	}


	shakeMe(stateVar: string) {
		if(this.loggedemployee) {
			this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
		}
	}

	shakeEnd(stateVar: string, event) {

		this.states[stateVar] = 'shakeend';
	}

	ngOnInit(): void {

		this.globalSearchService.mesagesallowed.next(false);


		this.currentstep = 0;
		this.route.params.subscribe(params => {
			if (params['cid'] != '' && this.debtorno != params['cid'] && this.branchcode != params['branch'] && params['cid'] !== undefined) {
				this.debtorno = params['cid'];
				this.branchcode = params['branch'];
				this.currentstep = 2;
				//load customer. cart. and totals.
				this.orderService.getCustomer(this.debtorno, this.branchcode).subscribe((results: any) => {

					this.globalSearchService.empCode.subscribe(r=> {
						if(r) {
							this.empcode.setValue(r);
							this.loggedemployee = r;
						}
					});

					this.customer_data = results;
					this.loadCustomerBranch();
					this.setCustomerForm();
					var details = results
					this.updateCart();
				});
			} else {
				setTimeout(()=>{
					this.empCodeRef.nativeElement.focus();
				},0);



			}
		});

		this.globalSearchService.payment_methods.subscribe((results: any) => {
			this.payments = results;
			if (this.payments) {
				this.payments.forEach((payment) => {
					payment.value = 0;
				});
			}
		});

		this.globalDiscount.valueChanges.subscribe(newvalue=> {
			this.updateDiscounts(newvalue);
		})

	}

	public checkCode() {
		let data =  {employee: this.empcode.value}
		if(this.empcode.value && this.empcode.value !='') {
			this.orderService.getEmployee(data).subscribe((result: any) => {
				if(result.success) {
					this.currentstep = 1;
					this.emperror = false;
					this.globalSearchService.empCode.next(this.empcode.value);
					this.loggedemployee = this.empcode.value;
				} else {
					this.globalSearchService.empCode.next(false);
					this.loggedemployee = false;
					this.shakeMe('state1');
					this.emperror = true;
				}
			});
		}

	}

	setCustomerForm() {

		if(this.customer_data) {
			var dnote = '';
			var inote = '';
			var ref = '';
			var card = false;
			//note already set re apply it
			if (this.customerForm) {
				if (this.customerForm.get('comments').value != '') {
					dnote = this.customerForm.get('comments').value;
				} else {
					dnote = this.customer_data.dispatchnote;
				}
				if (this.customerForm.get('notes').value != '') {
					inote = this.customerForm.get('notes').value;
				}

				if(this.customerForm.get('payment_method').value) {
					card = this.customerForm.get('payment_method').value;
				}
			}

			//reset form based on existing order details

			if (this.customer_data.editingorder) {
				dnote = this.customer_data.editingorder.notes;
				inote = this.customer_data.editingorder.comments;
				ref = this.customer_data.editingorder.customerref;

				//preselected payment method
				if (this.customer_data.preselected) {
					card = this.customer_data.preselected;
				}
			}

			if(this.user && this.user.user.defaultlocation.loccode != 	this.customer_data.defaultlocation) {
				this.customer_data.defaultlocation = this.user.user.defaultlocation.loccode;
			}

			this.customerForm = this.fb.group({
				debtorno: [this.customer_data.debtorno, Validators.required],
				branchcode: [this.customer_data.branchcode, Validators.required],
				name: [this.customer_data.name, Validators.required],
				address1: [this.customer_data.address1, Validators.required],
				address2: [this.customer_data.address2],
				address3: [this.customer_data.address3, Validators.required],
				address4: [this.customer_data.address4, Validators.required],
				address5: [this.customer_data.address5, Validators.required],
				address6: [this.customer_data.address6],
				brname: [this.customer_data.brname, Validators.required],
				braddress1: [this.customer_data.braddress1, Validators.required],
				braddress2: [this.customer_data.braddress2],
				braddress3: [this.customer_data.braddress3, Validators.required],
				braddress4: [this.customer_data.braddress4, Validators.required],
				braddress5: [this.customer_data.braddress5, Validators.required],
				braddress6: [this.customer_data.braddress6],
				reference: [ref],
				paymentterms: [this.customer_data.paymentterms, Validators.required],
				datewanted: [this.today, Validators.required],
				email: [this.customer_data.email],
				defaultlocation: [this.customer_data.defaultlocation, Validators.required],
				salesman: [this.customer_data.salesman, Validators.required],
				phoneno: [this.customer_data.phoneno],
				enteredby: [this.user.userid, Validators.required],
				takenby: [this.user.userid, Validators.required],
				defaultshipvia: [this.customer_data.defaultshipvia, Validators.required],
				salestype: [this.customer_data.salestype, Validators.required],
				freightcost: [0.00],
				comments: [dnote],
				notes: [inote],
				payment_method: [card]
				//quote: ['0', Validators.required]
			});

			if (this.customer_data.customerpoline === true || this.customer_data.customerpoline === '1') {
				this.customerForm.get('reference').setValidators([Validators.required])
				this.customerForm.get('reference').updateValueAndValidity();
				if (ref != '') {
					this.customerForm.get('reference').setValue(ref);
				}
			} else {

			}

			this.globalSearchService.shipvia.subscribe((results: any) => {
				if (results !== null) {
					this.shipvia = results;
					let shipvia = results.filter(v => {
						v.shipper_id == this.customer_data.defaultshipvia
					})[0]
					if (shipvia) {
						this.customerForm.get('freightcost').setValue(shipvia.mincharge);
					}
				}
			});


		}
	}


	getTotalItems() {

		var total = 0;
		if (this.cart_items.length) {
			total = this.cart_items.reduce(function(accumulator, c) {
				return accumulator + parseFloat(c.quantity);
			}, 0);
		}

		return total;
	}

	loadOrder(order: any) {

		this.orderService.loadSalesOrderPos(order.header.orderno, true).subscribe((results: any) => {
			this.editing_order = true;
			this.customer_data.editingorder = results.header;
			this.customer_data.preselected = results.preselected;
			this.order_details = results;
			this.cart_items = results.cart;
			this.updateTotals();
			this.modalService.dismissAll();
			this.cart_item = this.cart_items[0];
		})
	}

	back(): void {
		this.location.back()
	}

	randomString(length: any, chars: any) {
		var result = '';
		for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
		return result;
	}

	updateTax(item: any) {
		this.openModal(this.taxdetailsRef, item);
	}

	getItemDetails(item:any) {
		this.inventoryService.loadItem(item).subscribe((results: any) => {
			this.item_details = results;
			this.modalService.open(this.itemDetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
				//item

			}, (reason) => {
				this.item_details = false;
			});
		});
	}

	openModal(content, item) {

		this.item_details = item;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.item_details = false;
		});
	}

	editCustomerModal() {
		this.modalService.open(this.editCustomerRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	populateItem(item: any) {
		this.cart_item = item
	}
	invoice() {
		this.router.navigate(['/orders/invoice/' + this.orderResults.orderno]);
	}

	ngAfterViewInit() {

	}

	// CART FUNCTIONS
	setItemSelectedPoOption(item: any, data: any) {
		item.selected_po_option = data;
	}

	viewitemOrderHistory(item: any) {
		this.selecteditem = item;
		this.customerService.getCustomerHistoryItem(this.debtorno, item.stockid).subscribe((result: any) => {
			this.itemhistory = result
			this.modalService.open(this.itemHistoryRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result: any) => {

			}, (reason) => {
				this.itemhistory = [];
				this.selecteditem = false;
			});
		});
	}

	setPurchOrderOptions(cart_id: any, selected: any) {
		let data = { cart_id: cart_id, options: selected }
		this.orderService.setPoOptions(data).subscribe((results: any) => {
			this.modalService.dismissAll();
			this.purchase_items = [];
			this.orderService.getPosCart(this.debtorno, this.branchcode, this.customer_data.defaultlocation).subscribe(async (items: any) => {
				this.cart_items = items;
				this.updateTotals();
			});
		});

		this.sendCartUpdate();
	}

	viewPurchOrderOptions(line: any) {
		line.allownegative = true;
		let data = { cart_id: line.cart_id, stockid: line.stockid }
		this.orderService.getPurchDataFromLine(data).subscribe((results: any) => {
			this.purchase_items.push(results);
			this.modalService.open(this.purchasedetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				this.purchase_items = [];
			});
		});
	}

	toggleItemDsp(item: any) {
		if (!item.visible) {
			item.visible = true;
		} else {
			item.visible = false;
		}
	}

	removeFromOrder(cart_id) {
		this.orderService.removeFromOrderPos(cart_id, this.customer_data.debtorno, this.customer_data.branchcode, this.customer_data.defaultlocation , this.forceTax.value ).subscribe((results: any) => {
			this.cart_items = results;
			this.globalSearchService.showNotification('Item Removed', 'danger', 'bottom', 'left');
			this.updateTotals();
			this.sendCartUpdate();
			if (this.cart_items.length) {
				this.cart_item = this.cart_items[0];
			} else {
				this.cart_item = false;
			}
		});
	}

	sendCartUpdate() {

		if (this.user) {
			let data = [{ customer: this.customer_data.debtorno, user: this.user }]
			this.omsService.sendCartUpdate({ data, roomName: 'CartRoom' }, cb => {});
		}
	}

	updateTotals() {

		this.orderService.getPosTotals(this.customer_data.debtorno, this.customer_data.branchcode, this.shipping, this.customer_data.defaultlocation ).subscribe(async (results: any) => {
			this.cart_totals = results;
			this.total_cart_qty = this.cart_items.reduce(function(accumulator: number, items: any) {
				return accumulator + parseFloat(items.quantity);
			}, 0);

			this.checkCreditLimit()
		});

	}

	getTotal() {

		let total = this.cart_totals.filter(t => {
			return t.code == 'total';
		})[0]

		var value = 0.00;
		if (total) {
			value = parseFloat(parseFloat(total.text).toFixed(2))
		}

		return value;

	}

	reloadData() {

	}

	selectCustomer(row: any) {
		this.customerChanged(row);
		this.currentstep = 2;
		//this.customer_selected.emit(row);
	}

	customerChanged(customer: any) {
		this.customerinfo = true;
		this.selectedindex = 0;

		let data = {
			debtorno: customer.debtorno,
			branchcode: customer.branchcode,
			salestype: 10,
		}
		this.orderService.repriceCart(data).subscribe((result: any) => {
			this.orderService.getCustomer(customer.debtorno, customer.branchcode).subscribe((results: any) => {
				this.router.navigate(['/counter-pos/' + customer.debtorno + '/' + customer.branchcode]);
				this.customer_data = results;
				this.setCustomerForm();
			});
		});

	}

	nothing() {
		return false;
	}
	getFormValidationErrors() {
		Object.keys(this.customerForm.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = this.customerForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					this.customerForm.markAllAsTouched();
					this.itemSearchForm.markAsUntouched()
					this.customerinfo = true;
					if (key == 'reference') {
						key = 'PO Number';
					}
					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}


	checkCredit() {

		if (!this.allowed_credit && this.cart_totals.length) {

			this.proceed = true;

			let subtotal = this.cart_totals.filter(t => {
				return t.code == 'sub_total'
			})[0]

			if (subtotal && parseFloat(subtotal.text) > this.customer_data.credit_avail) {
				//alert("This order will Breech the customers credit limit ($"+this.customer_data.credit_avail+'/$'+this.customer_data.creditlimit+")")
				this.proceed = false;
			}
		}

		this.proceed = true;

	}

	checkCreditLimit() {

		//disabling credit check for now.
// 		if (!this.allowed_credit && this.cart_totals.length) {
// 			this.proceed = true;
// 			this.overcredit = false;
// 			let subtotal = this.cart_totals.filter(t => {
// 				return t.code == 'sub_total'
// 			})[0]
//
// 			if (subtotal && parseFloat(subtotal.text) > this.customer_data.credit_avail) {
// 				this.proceed = false;
// 				this.overcredit = true;
// 				if (this.overcredit_override == '') {
// 					this.orderService.flagCart(this.customer_data.debtorno, this.customer_data.branchcode).subscribe((result: any) => {
// 						this.overcredit_override = result
// 					})
// 				}
// 			}
// 		}
	}

	unlock() {
		if (this.proceed) {
			this.orderService.unflagCart(this.customer_data.debtorno, this.customer_data.branchcode).subscribe((result: any) => {
				this.overcredit_override = result
				this.overcredit = false;
				this.allowed_credit = true;
				this.modalService.dismissAll();
			})
		}
	}

	verifyUnlock(value: any) {
		this.proceed = false;
		value = value.toUpperCase()
		if (this.overcredit_override.toUpperCase() == value.toUpperCase()) {
			this.proceed = true;
		}

		return this.proceed;
	}

	updateItem(pdata: any) {
		this.purchase_items[0].allownegative = true;
		this.purchase_items[0].purchdata = pdata.purchdata
		this.updateTotals();
	}

	clearCartCancel() {

		this.orderService.clearOrder(this.customer_data.debtorno, this.customer_data.branchcode).subscribe((results: any) => {

			this.updateCart();
			this.customer_details = false;
			this.editing_order = false;
			this.order_details = false;
			this.cart_item = false;
			this.currentstep = 0;
			this.customer_data = [];
			this.router.navigate(['/counter-pos/']);

		});
	}

	clearOrder() {

		this.orderService.clearOrder(this.customer_data.debtorno, this.customer_data.branchcode).subscribe((results: any) => {

			this.updateCart();
			this.editing_order = false;
			this.order_details = false;
			this.cart_item = false;
			this.currentstep = 2;
		});
	}

	placeOpenOrder() {

		this.checkCredit();
		this.allowed_credit = true;
		if (!this.proceed && !this.allowed_credit) {
			this.modalService.open(this.creditover, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
				this.item_details = false;
			});
		}

		var customer = this.customer_data;

		if(this.customerForm) {
			customer = this.customerForm.value
		}

		this.orderService.createPosInvoice(customer, this.cart_items, this.cart_totals, this.user, this.loggedemployee ).subscribe((results: any) => {

			this.orderResults = results;
			this.orderService.clearOrder(this.debtorno, this.branchcode).subscribe((cleared: any) => {

				this.cart_items = [];
				this.pay_title = 'RECEIPT';
				this.orderService.getOrderReceipt(results.order).subscribe((rec: any) => {
					this.receipt_data = rec
				})

				this.total_cart_qty = 0;
				this.preOrderOpenState = false;

				this.globalDiscount.setValue(0);
				this.globalSearchService.empCode.next(false);
				this.loggedemployee = false;
				this.router.navigate(['/counter-pos/']);
				let data = { user: this.user };
					this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
				}, (reason) => {});
				this.currentstep = 1;
		});

	}

	placeOrder() {

		this.checkCredit();

		this.allowed_credit = true;
		if (!this.proceed && !this.allowed_credit) {
			this.modalService.open(this.creditover, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {
				this.item_details = false;
			});
		}

		var customer = this.customer_data;
		if(this.customerForm) {
			customer = this.customerForm.value
		}

		this.orderService.createOrderAndInvoicePos(customer, this.cart_items, this.cart_totals, this.user, this.loggedemployee).subscribe((orderresults: any) => {
			this.orderResults = orderresults;
			this.orderService.clearOrder(this.debtorno, this.branchcode).subscribe((cleared: any) => {


				this.cart_item = false;
				this.total_cart_qty = 0;
				let data = {};
				this.globalDiscount.setValue(0);
				this.globalSearchService.empCode.next(false);
				this.loggedemployee = false;
				this.cart_items = [];
				let url = '/pos/success/'+orderresults.transno
				this.router.navigate([url]);
			});
		});
	}

	addItems(items: any) {

		this.orderService.addMultipleToOrderPos(items, this.customer_data.debtorno, this.customer_data.branchcode, this.customer_data.defaultlocation, this.forceTax.value ).subscribe((results: any) => {

			if (results.success) {
				this.cart_items = results.cart;
				//this.updateTotals();
				let components = [];
				items.forEach((item, index) => {
					//reset qtys and show notification
					if (parseFloat(item.quantity) != 0) {
						let color = (item.isnegative) ? 'warn' : 'success';
						this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Added', color, 'bottom', 'right');
						this.cart_item = item;
					}
				});

				if (this.cart_items.length) {
					this.cart_item = this.cart_items[0];
				}

				this.updateTotals();
				if(this.globalon) {
					if(this.globalDiscount.value != '' && this.globalDiscount.value != 0){
						this.updateDiscounts(this.globalDiscount.value);
					}
				}
			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'right');
			}
		});
	}



	updateCart() {

		if (this.fetchingCart) {
			this.fetchingCart.unsubscribe();
		}

		if (this.customer_data.debtorno) {

			this.fetchingCart = this.orderService.getPosCart(this.customer_data.debtorno, this.customer_data.branchcode, this.customer_data.defaultlocation, this.forceTax.value ).subscribe((items: any) => {
				// alert('fetching cart');
				var cart_items = items;
				if (items.length) {
					//this.flip ='active';
					this.cart_item = items[0];
				}

				//current cart tied to a sales order - user loaded an order and left
				let hasorderno = items.map(item => { return (item.orderno != 0) ? item.orderno : false })[0];
				//todo rework this - doubles up on the calls
				if (hasorderno && !this.order_details.header) {
					this.orderService.loadSalesOrder(hasorderno, true).subscribe((results: any) => {
						this.editing_order = true;
						this.customer_data.editingorder = results.header;
						this.customer_data.preselected = results.preselected;
						this.order_details = results;
						this.cart_items = results.cart;
						if (results.cart.length) {
							this.cart_item = this.cart_items[0];
							//this.flip ='active';
						}
					});
				} else {
					this.cart_items = items;
				}

				this.updateTotals();
			});
		}
	}

	getDiscountTotal(item: any) {
		var discounted = (item.price * (item.discount / 100)).toFixed(2);
		var discountprice = (item.price - parseFloat(discounted))
		var total = item.quantity * discountprice;
		if (total < 0) {
			total = 0;
		}
		return total;
	}

	updatePrice(event: any, item: any) {
		if (event.target.value != '') {
			let index = this.cart_items.indexOf(item);
			this.cart_items[index].price = event.target.value;
			//this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
			this.updateCartItem(this.cart_items[index]);
		}
	}

	updateQuantity(event: any, item: any) {

		if (event.target.value != '') {
			let index = this.cart_items.indexOf(item);
			this.cart_items[index].quantity = event.target.value;
			//this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
			this.updateCartItem(this.cart_items[index]);
		}
	}

	updateDiscount(event: any, item: any) {
		var procced = false;
		if (parseFloat(event.target.value) < 100 && !isNaN(parseFloat(event.target.value))) {
			procced = true;
		} else {
			if (!isNaN(parseFloat(event.target.value))) {
				event.target.value = 100;
				procced = true;
			}

			if(event.target.value > 100) {
				event.target.value = 100;
			}

			if(event.target.value < 0) {
				event.target.value = 0;
			}
		}

		if (procced) {
			let index = this.cart_items.indexOf(item);
			this.cart_items[index].discount = event.target.value;
			this.updateCartItem(this.cart_items[index]);
		}
	}

	updateNote(event: any, item: any) {
		let index = this.cart_items.indexOf(item);
		this.cart_items[index].notes = event.target.value;
		this.updateCartItem(this.cart_items[index]);
	}

	updateCartItem(item: any) {

		let index = this.cart_items.indexOf(item);

		let data = {
			customer: this.customer_data.debtorno,
			branch: this.customer_data.branchcode,
			cartid: item.cart_id,
			cart_id: item.cart_id,
			price: item.price,
			option: item.option,
			quantity: item.quantity,
			discount: item.discount,
			notes: item.notes,
			stockid: item.stockid,
			coupon_used: item.coupon_used,
			editing_order: this.editing_order,
			order_details: this.order_details,
			location: this.customer_data.defaultlocation,
			forcetax: this.forceTax.value
		};

		this.orderService.updateOrder(data).subscribe((results: any) => {

			let existed = results.filter( i => {
				return i.cart_id == item.cart_id;
			})[0];

			if(existed) {
				this.cart_item.taxtotal = existed.taxtotal
				this.cart_item.taxdetails = existed.taxdetails
			}

			this.updateTotals();
			//this.updateCart();
			//item.cart_id
			//this.updateChildren();

		});
	}

	decrement(item: any) {
		let index = this.cart_items.indexOf(item);
		if(index >= 0) {
			if (this.cart_items[index].quantity > 0) {
				this.cart_items[index].quantity -= 1;
				this.updateCartItem(this.cart_items[index]);
			}

			if (this.cart_items[index].quantity == 0) {
				this.removeFromOrder(this.cart_items[index].cart_id);
			}
		}


	}

	increment(item: any) {
		let index = this.cart_items.indexOf(item);
		if(index >= 0) {
			this.cart_items[index].quantity += 1;
			this.updateCartItem(this.cart_items[index]);
		}
	}
	itemsearching: boolean = false;
	itemSearching(event: any) {
		this.itemsearching = event;
	}

	getDiscountPrice(item: any) {
		var total = (item.price - (item.price * (item.discount / 100)));
		// if(total < 0) {
		// 	total = 0;
		// }
		return this.financial(total);
	}

	getDiscount(item: any) {
		var total = ((item.price * (item.discount / 100)));
		// if(total < 0) {
		// 	total = 0;
		// }
		return this.financial(total);
	}

	financial(x) {
		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	focusToTop() {
		setTimeout(() => {
			this.editRowRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			this.itemQtyRef.nativeElement.focus();
		}, 0);
	}

	loadCustomerBranch() {

		if (!this.customer_data.branchcode) {
			this.customerService.getDebtor(this.customer_data.debtorno).subscribe(async (results: any) => {
				this.customer_details = results;
				this.refusedemail = this.customer_details.customer.refusedemail
			});
		} else {
			this.customerService.getDebtorWithBranch(this.customer_data.debtorno, this.customer_data.branchcode).subscribe(async (results: any) => {
				this.customer_details = results;
				this.refusedemail = this.customer_details.customer.refusedemail
			});
		}

		this.email.setValue(this.customer_details.invoiceemailaddress)
		this.updateCart();
	}

	salemanName(input: any) {
		let name = this.customer_details.salespeople.filter((p) => {
			return p.code == input
		})[0];
		if (name) {
			return name.name
		}
		return 'N/A';
	}

	saveQuote() {

		if (this.editing_order) {
			this.editing_order = true;
			var continueconfirm = confirm("This is an open order, save as a quote and cancel order?");
			if (continueconfirm) {
				this.orderService.cancelOrder(this.order_details.header.orderno).subscribe((results: any) => {});
			} else {
				return false;
			}
		}

		this.orderService.saveQuote(this.customer_data, this.cart_items, this.cart_totals, this.user).subscribe((result: any) => {
			this.globalSearchService.showNotification('Quote ' + result.orderno + ' Saved', 'success', 'bottom', 'left');
			this.clearOrder();
			this.loadCustomerBranch();
			this.globalSearchService.empCode.next(false);
			this.router.navigate(['/counter-pos/']);

		});
	}
	//todo
	loadQuoteModal() {
		this.modalService.open(this.quoteModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	loadOrderModal() {
		this.modalService.open(this.orderModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	changeBranch(branchcode: any) {
		this.customerService.getDebtorWithBranch(this.customer_data.debtorno, branchcode).subscribe(async (results: any) => {
			this.customer_details = results;
			this.refusedemail = this.customer_details.customer.refusedemail
			this.updateCart();
		});
	}

	updateCustomer(input: any) {

		this.customer_details = input;
		if(input.user.defaultlocation.loccode != this.ref_location) {
			if(this.customer_data) {
				this.customer_data.defaultlocation = this.user.user.defaultlocation.loccode;
			}
			this.ref_location = false;
		}

		this.updateCart();

	}

	loadQuote(quote: any) {

		this.orderService.loadQuote(quote.orderno).subscribe((r: any) => {
			this.changeBranch(r.header.branchcode);
			this.customer_data.debtorno = r.header.debtorno
			this.customer_data.branchcode = r.header.branchcode
			this.modalService.dismissAll();
			this.updateCart();
		})
	}

	loadSalesOrder(quote: any) {

		this.orderService.loadSalesOrder(quote.orderno , true).subscribe((r: any) => {
			this.changeBranch(r.header.branchcode);
			this.customer_data.debtorno = r.header.debtorno
			this.customer_data.branchcode = r.header.branchcode
			this.modalService.dismissAll();
			this.updateCart();
			this.cart_item = this.cart_items[0];
		})
	}

	checkStep(data: any) {
		this.currentstep = data.selectedIndex;

		switch(this.currentstep) {
			case 0:
				setTimeout(()=>{
					this.empCodeRef.nativeElement.focus();
				},10);
			break;
			case 1:
				this.customer_data = [];
				this.customer_details = false;
				this.cart_items = [];
				this.cart_item = false;
				this.router.navigate(['/counter-pos/']);
			break;
			case 2:
			break;
			case 3:
				this.checkDeals();
			break;
		}
	}

	getCartItemIndex(item: any) {
		let index = this.cart_items.indexOf(item);
		return index;
	}

	loadOrders() {
		this.flip = 'active';
	}

	applyCoupon(input: any) {

	}
	addCoupon(input: any, item: any) {

	}

	showCoupons() {
		// 	this.modalService.open(this.couponModalRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {
		//
		// 	}, (reason) => {
		// 		this.purchase_items = [];
		// 	});
	}

	getBalance() {
		if(this.cart_totals.length) {
			let total = this.cart_totals.filter(t => {
				return t.code == 'total';
			})[0];

			var total_amount = 0.00;
			if (total) {
				total_amount = total.text
			}

			var value = this.financial(total_amount) - this.financial(this.payment_total);
			if (value < 0) {
				this.change_due = 0;
				this.payments.forEach((pay) => {
					//Is there cash involved, then we can give change.
					if (pay.opencashdrawer == '1' && pay.value > 0 && value < 0) {
						//It's cash!
						if (pay.value > Math.abs(value)) {
							this.change_due = Math.abs(value);
							value = 0;
						} else {
							this.change_due = pay.value;
							value = value + pay.value;
						}
					} else {}

				});
			} else {
				this.change_due = 0;
			}
		} else {
			var value = 0.00;
		}

		return value;
	}

	// updatePayments(event: any, payment: any) {
	// 	const parent = this
	// 	payment.value = this.financial(event.target.value);
	// 	this.payment_total = this.payments.reduce(function(accumulator, item) {
	// 		return parent.financial(accumulator) + parent.financial(item.value);
	// 	}, 0);
	// }

	updatePayments(event: any) {

		if(event) {
			this.payments_added = event;
			this.payment_total = this.payments_added.reduce(function(accumulator, item) {
				return parseFloat(accumulator) + parseFloat(item.amount);
			}, 0);
		}

		let data = {
			orderno: (this.order_details && this.order_details.header) ? this.order_details.header.orderno : '1',
			debtorno: this.customer_data.debtorno,
			branchcode: this.customer_data.branchcode,
		}

		this.paymentsService.getPosOrderPayments(data).subscribe((results: any) => {
			this.payments = results;
			this.payments.forEach((payment) => {
				//reduce cash payment by change due
				if (this.change_due > 0 && payment.opencashdrawer == '1' && payment.value > 0) {
					payment.value = this.financial(payment.value) - this.financial(this.change_due);
				}

				if (this.financial(payment.amount) > 0) {

					const data = {
						payment: {
							amount: this.financial(payment.amount),
							reference: payment.reference,
							type: payment.payment_type,
							bankaccount: payment.bankaccount
						},
						order: {
							orderno: false,
							debtorno: this.customer_data.debtorno,
							branchcode: this.customer_data.branchcode
						}
					};
				}
			});

			this.updateTotals()
			this.payment_total = this.financial(results.reduce(function(accumulator, item) {
				return parseFloat(accumulator) + parseFloat(item.amount);
			}, 0));

		});

	}

	applyDeal(dealcode: any) {
		let data = {
			debtorno: this.customer_data.debtorno,
			branchcode: this.customer_data.branchcode,
			dealid: dealcode,
		}
		this.orderService.applyDeal(data).subscribe((result: any) => {
			if (result.success) {
				this.sendCartUpdate();
				this.checkDeals();
			}
		});
	}

	checkDeals() {
		let data = {
			debtorno: this.customer_data.debtorno,
			branchcode: this.customer_data.branchcode
		}
		this.orderService.getDealCheck(data).subscribe((result: any) => {
			if (result.promofound) {
				this.dealsmissed = result.promolist;
			} else {
				this.dealsmissed = [];
			}
		});
	}

	updateDiscounts(value) {
		if(this.globalon) {
			if(!isNaN(value) && value != '') {

				if(value > 100) {
					value = 100;
				}

				if(value < 0) {
					value = 0;
				}

				let data = {
					debtorno: this.customer_data.debtorno,
					branchcode: this.customer_data.branchcode,
					discount: this.financial(value),
				}

				if(this.sendingdiscount) {
					this.sendingdiscount.unsubscribe();
				}
				this.sendingdiscount = this.orderService.updateCartItemsDiscountPos(data).subscribe( r=> {
					this.updateCart();
				});
			} else {
				value = 0;
			}
		}
	}

	completeOrder() {
		this.payments.forEach((payment) => {
			//reduce cash payment by change due
			if (this.change_due > 0 && payment.opencashdrawer == '1' && payment.value > 0) {
				payment.value = this.financial(payment.value) - this.financial(this.change_due);
			}


			if (this.financial(payment.amount) > 0) {

				const data = {
					payment: {
						amount: this.financial(payment.amount),
						reference: payment.reference,
						type: payment.payment_type,
						bankaccount: payment.bankaccount
					},
					order: {
						orderno: false,
						debtorno: this.customer_data.debtorno,
						branchcode: this.customer_data.branchcode
					}
				};
			}
		});

		this.placeOrder();

	}

	addPromo(promo: any) {
		this.orderService.addPromoPos(promo, this.customer_data.debtorno, this.customer_data.branchcode).subscribe((results: any) => {
			if (results.success) {

				this.cart_items = results.cart;
				this.updateTotals();
				this.globalSearchService.showNotification(results.message, 'success', 'bottom', 'right')

			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
			}
		});

	}

	getBrandSales(debtorno: any, brand: any) {

		var today = new Date();
		//var priorDate = new Date(new Date().setDate(today.getDate() - this.daysmax));

		let data = {
			debtorno: debtorno,
			brands: [brand],
			from: 'all',
			//to: today,
		}

		this.customerService.searchCustomerHistory(data).subscribe(async (results: any) => {
			this.sending = false;
			this.brand_details = results;
			this.modalService.open(this.monthDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	togglePreOrder() {

		this.preOrderOpenState = (this.preOrderOpenState) ? false: true;

		if(this.preOrderOpenState) {
			this.setCustomerForm();
		}

	}

	printReceipt() {
		let data = {
			id: this.receipt_data.id
		}
		this.orderService.printOrderReciept(data).subscribe( r=> {

		});
	}

	emailReceipt() {
		let data = {
			id: this.receipt_data.id
		}
		this.orderService.emailOrderReciept(data).subscribe( r=> {

		});
	}
	ngOnChanges(changes: any) {
	}

	isActiveText() {

		if(this.customer_details) {
			return (this.customer_details.customer.isactive) ? 'ACTIVE' : 'INACTIVE';
		}
		return '';
	}

	updateActive(event:any) {
		//event.preventDefault();
		if(this.customer_details.customer.isactive) {
			let confirmed = confirm("Mark Customer as Inactive?");
			if(confirmed) {
				let data = {
					debtorno: this.customer_details.debtorno,
					branchcode: this.customer_details.branchcode,
					isactive: false
				}
				this.customerService.updateDebtorActive(data).subscribe( (results) => {
					this.customer_details = results;
					this.updateCart();
				});
			} else {
				return false;
			}
		} else {
			this.modalService.open(this.inactiveModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {
				this.reactivateCustomer();
			});
		}
	}

	updateBranch(input: any) {
		this.customerService.getDebtor(this.debtorno).subscribe((results: any) => {
			this.customer_details = results;
			this.refusedemail = this.customer_details.customer.refusedemail
			this.modalService.dismissAll('close');
			this.updateCart();
		});
	}

	reactivateCustomer() {

		let data = {
			debtorno: this.customer_details.debtorno,
			branchcode: this.customer_details.branchcode,
			isactive: true
		}

		this.customerService.updateDebtorActive(data).subscribe( (results) => {
			this.customer_details = results;
			this.updateCart();
		});
	}

	addNonStockItem(event: any) {

		let item = event;
		let data = { item: item, debtorno: this.customer_data.debtorno, branchcode: this.customer_data.branchcode , location: this.customer_data.defaultlocation, forcetax: this.forceTax.value }

		this.orderService.addNonStock(data).subscribe((results: any) => {
			this.globalSearchService.showNotification(item.description + ' x ' + item.qty + ' Added', 'success', 'bottom', 'right');
			this.updateCart();
		});
	}

	getTaxDisplay(amount: any) {

		if(amount && !isNaN(amount)) {
			return this.financial(amount * 100);
		}

		return 0.00
	}

	updateTaxRate(newvalue: any, tax: any) {
		//rounding on the other side
		tax.taxrate = newvalue / 100;
	}

	focusSearch() {
		let ref = document.getElementById('searchkeywords');
		setTimeout(()=>{
			ref.focus();
		},0);
	}

	updateRefused(event:any) {

		this.refusedemail = event.target.checked;

		let data = {
			debtorno: this.customer_details.debtorno,
			branchcode: this.customer_details.branchcode,
			refusedemail: event.target.checked
		}

		this.customerService.updateDebtorRefused(data).subscribe( (results) => {
			this.customer_details = results;
			if(!event.target.checked) {
				this.editCustomerModal()
			}
		});
	}

}
